const color = {

    'white': '#FFFFFF',
    'red': '#FF0B0B',
    'blue': '#0d6efd',
    'light-blue': '#00E1FF',
    // 'statusBadge(orange)': '#f97316',
    // 'statusBadge(green)': '#22c55e',
    'riskMedium': '#EDB534',
    'riskLow': '#10B981',
    'riskHigh': '#E56A49',
    'riskCritical': '#A8020B',
    'riskGreen': '#10B981',
    'text(grey)': '#94A3B8',    
    'primary(blue)': '#3b82f6',
    'critical(red)': '#790000',
    'high(red)': '#DC1034',
    'body': '#000000ab'
};

// ─────────────────────────────────────────────────────────────
// DARK component theme (legacy) — used by NotificationBell,
// WhatsNewPopover and the Vulnerability tables. DO NOT retheme in
// place: those components render on the dark dashboard. Kept as-is
// for backward compatibility.
// ─────────────────────────────────────────────────────────────
export const theme = {
    surface: '#0d1117',              // panel background
    border: '#1f2937',               // panel border + header/section dividers
    headerBg: 'rgba(14, 22, 40, 0.6)', // panel header background
    itemBorder: '#161b22',           // row separator
    shadow: '0 12px 32px rgba(0, 0, 0, 0.45)',
    scrollThumb: '#1e293b',

    titleText: '#e2e8f0',            // headings / row titles
    bodyText: '#94a3b8',             // body / secondary text
    mutedText: '#64748b',            // dates / empty states

    primary: '#3b82f6',              // links / actions
    danger: '#ef4444',
    // badge accents
    successBg: 'rgba(34, 197, 94, 0.15)',
    successText: '#22c55e',
};

// ─────────────────────────────────────────────────────────────
// LIGHT THEME — the new global design tokens (off-white + blue).
// This is the single source of truth for colours in JS. It mirrors
// 1:1 the CSS custom properties declared in `src/styles/theme.css`
// (`--color-*`). Change a value here AND there to retheme globally.
//
// Semantic groups: surfaces, borders, text, brand/actions, status,
// data-viz, effects (shadow/radius). Reference every UI colour from
// here (or from the matching CSS var) instead of hardcoding hex.
// ─────────────────────────────────────────────────────────────
export const lightTheme = {
    // Brand navy (base hue) + gradients
    brandNavy: '#1e3c65',
    brandNavyDark: '#152c4b',
    brandNavyLight: '#315a8c',
    gradientBrand: 'linear-gradient(135deg, #1e3c65 0%, #315a8c 100%)',
    gradientSidebar: 'linear-gradient(180deg, #234670 0%, #17304f 100%)',
    gradientCanvas: 'linear-gradient(180deg, #EEF2F8 0%, #F8FAFC 100%)',

    // Surfaces — whitish neutrals
    canvas: '#F1F4F9',          // app / page background
    surface: '#FFFFFF',         // cards, panels
    surfaceMuted: '#F1F4F9',    // inset rows, secondary cards
    surfaceHover: '#EAEFF6',    // hover state on rows / list items
    tableHeader: '#EFF3F8',     // table header row background
    header: '#FFFFFF',          // top header bar
    sidebar: '#1e3c65',         // left navigation (fallback under gradient)
    modal: '#FFFFFF',           // modal / dialog background
    modalOverlay: 'rgba(16, 24, 40, 0.45)',

    // Borders — hairline
    border: '#E4E8EF',          // default card / divider border
    borderStrong: '#D0D7E2',    // inputs, emphasised dividers

    // Text — cool slate
    textPrimary: '#14213A',     // headings / strong text
    textSecondary: '#566175',   // body / secondary text
    textMuted: '#8A93A3',       // captions / placeholder / disabled
    textInverse: '#FFFFFF',     // text on dark / coloured surfaces

    // Brand / actions — navy
    primary: '#1e3c65',         // primary action / links
    primaryHover: '#152c4b',
    primarySoft: '#E8EEF6',     // tinted backgrounds (active nav, selected)

    // Status — muted, professional
    success: '#1F9254',
    successSoft: '#E4F4EA',
    danger: '#D33B3B',
    dangerSoft: '#FBE9E9',
    warning: '#C77A15',
    warningSoft: '#FBF0DD',
    info: '#1E7FB8',
    infoSoft: '#E6F1F8',

    // Data-viz / charts
    chartBlue: '#2A63D6',
    chartRed: '#D33B3B',
    chartPurple: '#5B5BD6',
    chartGreen: '#1F9254',

    // Effects — shadows (subtle, layered)
    shadowSm: '0 1px 2px rgba(16, 24, 40, 0.04)',
    shadow: '0 1px 3px rgba(16, 24, 40, 0.06), 0 1px 2px rgba(16, 24, 40, 0.04)',
    shadowLg: '0 8px 24px rgba(16, 24, 40, 0.10)',

    // Effects — radius (tight, considered)
    radiusSm: '6px',
    radius: '10px',
    radiusLg: '12px',
    radiusPill: '999px',
};

export default color;